<template lang="pug">
shListData(title="Transportadoras" resolver="conveyors" keyData="conveyor" component="shConveyor")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Conveyors',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/conveyor/Conveyors.vue